import { generatePath } from "react-router";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

export const BLOG_PATH = "/blog";
export const ARTICLE_PREVIEW_PATH = `${BLOG_PATH}/:articleId/apercu`;

export const getArticlePreviewPath = (articleId: string): string => generatePath(ARTICLE_PREVIEW_PATH, { articleId });

const BlogPage = lazyWithRetry(() => import("@/features/blog/pages/BlogPage"));
const ArticleDetailPage = lazyWithRetry(() => import("@/features/blog/pages/ArticleDetailPage"));
const ArticlePreviewPage = lazyWithRetry(() => import("@/features/blog/pages/ArticlePreviewPage"));

const blogRoutes: RouteConfig[] = [
  {
    path: BLOG_PATH,
    element: <BlogPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: `${BLOG_PATH}/:articleId`,
    element: <ArticleDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: ARTICLE_PREVIEW_PATH,
    element: <ArticlePreviewPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default blogRoutes;
